import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import { CASINO_VIDEO_URL } from "../../utils/constants";
import CasinoPage from "./components/CasinoPage";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { getCasinoExposureAPI, getCasinoOddsAPI } from "../../service/casino";
import { useLocation } from "react-router-dom";

export default function Card32A() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "CARD_32";
  const VIDEO_ID = 3056;
  const dispatch = useDispatch();

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );
  const [casinoPlData, setCasinoPlData] = useState([]);
  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);
  return (
    <CasinoPage
      casino={casinoData?.data}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardA}
      VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      shortName={"cards32a"}
      gameName={"Card 32"}
    >
      <div className="casino-detail">
        <div className="casino-table  ">
          <div className="casino-table-box ">
            <div className="casino-table-left-box ">
              <div className="casino-table-header ">
                <div className="casino-nation-detail ">
                  <div className="min_max_odds justify-content-start d-lg-none d-flex ">
                    <span className="min_max_span ms-0 ">
                      <b className="">Min:</b>
                      <span className="">
                        {" "}
                        100 {/**/}
                        {/**/}
                      </span>
                    </span>
                    <span className="min_max_span ms-1 ">
                      <b className="">Max:</b>
                      <span className="">
                        {" "}
                        100000 {/**/}
                        {/**/}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="casino-odds-box back ">Back</div>
                <div className="casino-odds-box lay ">Lay</div>
              </div>
              <div className="casino-table-body ">
                <div className="casino-table-row  ">
                  <div className="casino-nation-detail ">
                    <div className="casino-nation-name ">
                      {" "}
                      Player 8{" "}
                      <p className="">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player 8"
                        )}
                      </p>
                    </div>
                  </div>
                  <div
                    className={` casino_odds_row ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <div
                      onClick={() =>
                        setBet("Player 8", casinoData, dispatch, "back")
                      }
                      className="casino-odds-box back "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 8", casinoData, true)}
                      </span>
                      <p className="">
                        {" "}
                        {getOddForEntity("Player 8", casinoData, true, true)}
                      </p>
                    </div>
                    <div
                      onClick={() =>
                        setBet("Player 8", casinoData, dispatch, "lay")
                      }
                      className="casino-odds-box lay "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 8", casinoData, false)}
                      </span>
                      <p className="">
                        {getOddForEntity("Player 8", casinoData, false, true)}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="casino-table-row  ">
                  <div className="casino-nation-detail ">
                    <div className="casino-nation-name ">
                      {" "}
                      Player 9{" "}
                      <p className="">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player 9"
                        )}
                      </p>
                    </div>
                  </div>
                  <div
                    className={` casino_odds_row ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }
              }`}
                  >
                    <div
                      onClick={() =>
                        setBet("Player 9", casinoData, dispatch, "back")
                      }
                      className="casino-odds-box back "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 9", casinoData, true)}
                      </span>
                      <p className="">
                        {" "}
                        {getOddForEntity("Player 9", casinoData, true, true)}
                      </p>
                    </div>
                    <div
                      onClick={() =>
                        setBet("Player 9", casinoData, dispatch, "lay")
                      }
                      className="casino-odds-box lay "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 9", casinoData, false)}
                      </span>
                      <p className="">
                        {getOddForEntity("Player 9", casinoData, false, true)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider " />
            <div className="casino-table-right-box ">
              <div className="casino-table-header d-none d-md-flex ">
                <div className="casino-nation-detail " />
                <div className="casino-odds-box back ">Back</div>
                <div className="casino-odds-box lay ">Lay</div>
              </div>
              <div className="casino-table-body ">
                {/**/}
                {/**/}
                {/**/}
                {/**/}
                <div className="casino-table-row  ">
                  <div className="casino-nation-detail ">
                    <div className="casino-nation-name ">
                      {" "}
                      Player 10{" "}
                      <p className="">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player 10"
                        )}
                      </p>
                    </div>
                  </div>
                  <div
                    className={` casino_odds_row ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }
              }`}
                  >
                    <div
                      onClick={() =>
                        setBet("Player 10", casinoData, dispatch, "back")
                      }
                      className="casino-odds-box back "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 10", casinoData, true)}
                      </span>
                      <p className="">
                        {" "}
                        {getOddForEntity("Player 10", casinoData, true, true)}
                      </p>
                    </div>
                    <div
                      onClick={() =>
                        setBet("Player 10", casinoData, dispatch, "lay")
                      }
                      className="casino-odds-box lay "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 10", casinoData, false)}
                      </span>
                      <p className="">
                        {getOddForEntity(
                          "Player 10",
                          casinoData,
                          false,
                          true
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                {/**/}
                {/**/}
                <div className="casino-table-row  ">
                  <div className="casino-nation-detail ">
                    <div className="casino-nation-name ">
                      {" "}
                      Player 11{" "}
                      <p className="">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player 11"
                        )}
                      </p>
                    </div>
                  </div>
                  <div
                    className={` casino_odds_row ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }
              }`}
                  >
                    <div
                      onClick={() =>
                        setBet("Player 11", casinoData, dispatch, "back")
                      }
                      className="casino-odds-box back "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 11", casinoData, true)}
                      </span>
                      <p className="">
                        {" "}
                        {getOddForEntity("Player 11", casinoData, true, true)}
                      </p>
                    </div>
                    <div
                      onClick={() =>
                        setBet("Player 11", casinoData, dispatch, "lay")
                      }
                      className="casino-odds-box lay "
                    >
                      <span className="casino-odds ">
                        {getOddForEntity("Player 11", casinoData, false)}
                      </span>
                      <p className="">
                        {getOddForEntity(
                          "Player 11",
                          casinoData,
                          false,
                          true
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CasinoPage>
  );
}
